module.exports = __webpack_public_path__ + "img/batareya_otopleniya.09b7ca5c.svg";